/** "N changed" (amber) / "Identical" (green) badge for comparison rows.
 * Renders nothing when there is no comparison baseline (count == null). */
export function DiffBadge({ count }: { count: number | null | undefined }) {
  if (count == null) return null;
  return count > 0 ? (
    <span className="text-xs font-medium text-amber-600 dark:text-amber-400">{count} changed</span>
  ) : (
    <span className="text-xs font-medium text-green-600 dark:text-green-400">Identical</span>
  );
}
